import Button from '@/components/Buttons/Button';
import IconButton from '@/components/Buttons/IconButton';
import { MaskedIcon } from '@/components/MaskedIcon/MaskedIcon';
import ArrowLeft from '@/images/arrows/ArrowLeft.svg';
import { AppRoutes } from '@/utils/types';
import styled from '@emotion/styled';
import { useTheme } from '@mui/material';
import { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import TitleInput from '../TitleInput';
import TranslationGenerateDropdown from '../TranslationGenerateDropdown/TranslationGenerateDropdown';
import { PAGE_HEADER_HEIGHT } from '../constants';
import BackButtonConfirmationModal from './BackButtonConfirmationModal';
import RestoreOriginal from './RestoreOriginal';

const Header = styled.header`
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: ${PAGE_HEADER_HEIGHT};
    border-bottom: 1px solid ${({ theme }) => theme.colors.black[300]};
    padding: 0 3.2rem;
    flex-shrink: 0;
`;

const TranslateButton = styled(Button)`
    font-size: 1.8rem;
    height: 4.4rem;
    width: 18rem;
`;

const SubContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 2.4rem;
`;

function TranslationEditorPageHeader() {
    const [confirmationModalOpen, setConfirmationModalOpen] = useState(false);
    const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
    const { formState } = useFormContext();
    const navigate = useNavigate();
    const theme = useTheme();

    function handleTranslateButtonClick(event: React.MouseEvent<HTMLButtonElement>) {
        setAnchorEl(event.currentTarget);
    }

    async function handleBackButtonClick() {
        if (formState.isDirty) {
            setConfirmationModalOpen(true);
        } else {
            navigate(AppRoutes.Translation);
        }
    }

    function handleDropdownClose() {
        setAnchorEl(null);
    }

    return (
        <>
            <Header>
                <SubContainer>
                    <IconButton
                        testId="translation-draft-back-button"
                        ariaLabel="translation-draft-back-button"
                        onClick={handleBackButtonClick}>
                        <MaskedIcon src={ArrowLeft} size="32px" color={theme.colors.black[700]} />
                    </IconButton>
                    <TitleInput />
                </SubContainer>
                <SubContainer>
                    <RestoreOriginal />
                    <TranslateButton data-testid="translation-header-translate-button" onClick={handleTranslateButtonClick}>
                        Translate video
                    </TranslateButton>
                    <TranslationGenerateDropdown open={!!anchorEl} anchorEl={anchorEl} onClose={handleDropdownClose} />
                </SubContainer>
            </Header>
            <BackButtonConfirmationModal
                open={confirmationModalOpen}
                onClose={() => {
                    setConfirmationModalOpen(false);
                }}
            />
        </>
    );
}

export default TranslationEditorPageHeader;
